import { ReactNode } from 'react';

interface Props {
  icon: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

/**
 * Ilustrowany empty state — zamiast nudnego tekstu "Brak danych".
 * Użycie:
 *   <EmptyState
 *     icon={<Megaphone size={48} />}
 *     title="Brak podłączonych kont"
 *     description="Dodaj pierwsze konto Google Ads żeby zobaczyć dane."
 *     action={<button className="btn-primary">Dodaj konto</button>}
 *   />
 */
export function EmptyState({ icon, title, description, action, className }: Props) {
  return (
    <div className={`flex flex-col items-center justify-center py-16 ${className ?? ''}`}>
      <div className="h-20 w-20 rounded-2xl bg-gradient-to-br from-brand-50 to-brand-100 dark:from-brand-900/20 dark:to-brand-800/20 flex items-center justify-center mb-5 text-brand-400">
        {icon}
      </div>
      <h3 className="text-lg font-semibold text-slate-800 dark:text-slate-200 mb-1">{title}</h3>
      {description && (
        <p className="text-sm text-slate-500 dark:text-slate-400 max-w-sm text-center mb-5">{description}</p>
      )}
      {action}
    </div>
  );
}
